import { OrderQuantityWithKit } from '../../../../@types/python.d';

export const getCheckedoutQuantity = ({
	orderQuantitiesWithKits,
	orderId,
	kitId,
}: {
	orderQuantitiesWithKits: OrderQuantityWithKit[] | undefined;
	orderId?: string;
	kitId?: string | null;
}) =>
	orderQuantitiesWithKits?.reduce((total, orderQuantity) => {
		const orderMatch = orderId ? orderQuantity.orderId == orderId : true;
		const kitMatch = kitId !== undefined ? orderQuantity.kitId == kitId : true;
		if (orderMatch && kitMatch) {
			total += orderQuantity.quantity;
		}
		return total;
	}, 0) ?? 0;

export const getLooseCheckedoutQuantity = (orderQuantitiesWithKits: OrderQuantityWithKit[] | undefined) =>
	getCheckedoutQuantity({
		orderQuantitiesWithKits,
		kitId: null,
	});
